import { useJsApiLoader } from "@react-google-maps/api";
import React from "react";

const libraries = ["places"];

const GoogleMapsLoader = ({ children, apiKey }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    libraries, 
  });

  if (loadError) {
    return <div>Google Maps yüklenirken bir hata oluştu.</div>;
  }

  if (!isLoaded) {
    return <div>Google Maps yükleniyor...</div>;
  }

  return children; // Yükleme tamamlandıktan sonra alt bileşenleri render et.
};

export default GoogleMapsLoader;
